import React, { useEffect, useState } from "react";
import Constants from "../../constants";
import { getAPIService, postAPIService } from "../API";
import { decodeUserToken } from "../../utils";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import OHSkeleton from "../Skeletons/OHSkeleton";
import HoverRating from "./rating";
import CustomizedSnackbars from "../Shared/SnackBar";
import styled from "styled-components";
import { useSelector } from "react-redux";

const Review = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(false);
  const [orderDetails, setOrderDetails] = useState({});
  const orderNumQuery = searchParams.get("orderId");
  const { orderReleaseList = [] } = orderDetails;

  const getOrderDetails = async () => {
    setError(false);
    const URL = `${Constants.orders.getOrderDetails}?orderNumber=${orderNumQuery}`;
    const response = await getAPIService({ url: URL });
    const { status = 100, data = {} } = response;
    if (status === 200) {
      setOrderDetails(data);
      setLoading(false);
      setError(false);
    } else {
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    getOrderDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ReviewContainer = styled.div`
  
  margin-top: 11rem;
  margin-bottom: 5rem;
  padding-top: rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 811px;
  margin: 3rem auto;
  margin-top: 5rem;
  border-radius: 5px;
  border: 1px solid rgba(224, 224, 224, 0.77);

  .reviewtilecont{
  width:100%;
  }

  .reviewcontainermain{
  width:100%;
  }
  .reviewmainmain{
  width:100%;
  }
  `

  return (
    <React.Fragment>
      <ReviewContainer maxWidth={"md"}>

          <div className="reviewmainmain">
            {loading && <OHSkeleton />}
            {!loading && (
    
                <div
              className="reviewcontainermain"
                >
               
                  <div className="reviewtilecont" >
                    {orderReleaseList?.length > 0 &&
                      orderReleaseList?.map((SingleItem,index) => (
                        <SingleOrderReviewTile itemDetails={SingleItem} key={index} />
                      ))}
                  </div>
                </div>
            
            )}
          </div>
        
      </ReviewContainer>
    </React.Fragment>
  );
};
export default Review;

export const SingleOrderReviewTile = (props) => {
  const { itemDetails = {} } = props;
  const { orderItems = [] } = itemDetails;
  return (
    <>
      {orderItems?.length > 0 &&
        orderItems?.map((item) => <SingleTileReview key={item.sku} item={item} />)}
    </>
  );
};

export const SingleTileReview = (props) => {
  const { userId = "" } = decodeUserToken();
  const navigate = useNavigate();
  const { item = {} } = props;
  const { imageUrl, name } = item;
  const [value, setValue] = React.useState(0);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [reviewComments, setReviewComments] = useState("");
  // const [orderDetails, setOrderDetails] = useState({});
  const [alert, setAlert] = useState({
    isAlert: false,
    type: "",
    msg: "",
  });

  useEffect(() => {
    if (!value) {
      setSubmitDisabled(true);
    } else {
      setSubmitDisabled(false);
    }
  }, [value]);

  const handleComments = (e) => {
    let value = e.target.value;
    setReviewComments(value);
  };
   const details = useSelector((state) => state.userDetails)
console.log('detailsssssss are',details)
  const submitProductReview = async ({ prdRating, comment, sku }) => {

    console.log('are we submitting')
    const URL = `${Constants.reviews.AddUserReview}`;
    const payload = {
      userId,
      fullName:details.userProfile.fullName,
      rating: prdRating,
      comment: document.getElementById('review').value,
      sku: sku,
    };

    const response = await postAPIService({ url: URL, data: payload });
    const { status = 100 } = response;
    if (status === 200) {
      // setOrderDetails(data);
      setAlert({
        isAlert: true,
        type: "success",
        msg: "Rating Updated Successfully.",
      });
      setTimeout(() => {
        navigate("/myaccount/orders");
      }, 1000);
    } else {
      setAlert({
        isAlert: true,
        type: "error",
        msg: "Something went wrong, please try again.",
      });
    }
  };

  const ReviewTile = styled.div`
  width: 100%;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem 1rem;
  
  .titleimagetitle{
  font-size: 1rem;
  color: #222;
font-family: "Ancizar Sans", sans-serif;
  }
  `

  const ReviewTileImage = styled.div`
  img{
  border-radius: 5px;
  }
  
  
  `
  const ReviewTileInner = styled.div`

  width: 100%;
  
  
  `
  const TileText = styled.div`
  font-size: 15px;
  font-family: "Ancizar Sans", sans-serif;
  color: #222;
  margin-bottom: .5rem;
  `
    const TileText2 = styled.div`
  font-size: 15px;
  font-family: "Ancizar Sans", sans-serif;
  color: #222;
  margin-bottom: .5rem;
  margin-top: .5rem;
  `

  const  ButtonMain = styled.button`
  
  width: 121px;
  height: 35px;
  background-color:rgba(242, 86, 24, 0.94);
  color:#fff;
  font-size: 13px;
  outline:none;
  border:none;
  margin-top: 1rem;
  border-radius: 55px;
  cursor:pointer;

  
  `
  const InpuMain = styled.input`
  width: 100%;
  min-height: 4rem;
  type: textfield;
  border: 1px solid rgba(91, 91, 91, 0.46);
  border-radius: 5px;
  outline: none;
  `


  return (
    <React.Fragment key={name}>
      <ReviewTile sx={{ flexGrow: 1, m: 5 }} key={name}>
        <ReviewTileInner>
          <ReviewTileImage >
            <img src={imageUrl} alt="delivery_img" height={80} width={80} />
          </ReviewTileImage>
          <div className="titleimagetitle">
            {name}
          </div>
          <div >
            <TileText>
              {`Please rate your experience with this product`}</TileText>
            <div item>
              <HoverRating value={value} setValue={setValue} />
            </div>
          </div>

          <div >
            <TileText2
              variant="body"
              component="div"
              sx={{ pt: 2, pb: 2 }}
              fontWeight={500}
            >
              {`Add a written review: (optional)`}
            </TileText2>
            <InpuMain
             id={`review-${name}`} 
              placeholder="what did you like or dislike? what did you use this product for?"
             
              value={reviewComments}
              onChange={handleComments}
            />
          </div>
          <div xs={12} textAlign={"end"} pt={2} pb={2}>
            <ButtonMain
              onClick={() =>
                submitProductReview({
                  prdRating: value,
                  comment: reviewComments,
                  sku: item?.sku,
                })
              }
              variant="contained"
              sx={{ color: "white" }}
              /* disabled={submitDisabled} */
            >
              Submit
            </ButtonMain>
          </div>
        </ReviewTileInner>
      </ReviewTile>
      <Grid>
        {alert?.isAlert && (
          <CustomizedSnackbars
            text={alert?.msg}
            isOpen={alert?.isAlert}
            type={alert?.type}
          />
        )}
      </Grid>
    </React.Fragment>
  );
};
